let token = document.head.querySelector('meta[name="csrf-token"]');
let csrf_token = '';
if (token) {
    csrf_token = token.content;
}
const CSRF_TOKEN = csrf_token;
const API_BASE_URL = "/api/v3";
const APPLICANT_API_BASE_URL = "/applicant-api/v1";
const RECRUITER_API_BASE_URL = "/recruiter-api/v1";
const USER_API_BASE_URL = "/user-api/v1";
const EXTERNAL_API_BASE_URL = "/api/external";
let referrer_meta = document.head.querySelector('meta[name="referrer-base-url"]');
let referrer_base_url = '';
if (referrer_meta) {
    referrer_base_url = referrer_meta.content;
}
const REFERRER_PORTAL_BASE_URL = `${referrer_base_url}`;
const REFERRER_PORTAL_API_BASE_URL = `${referrer_base_url}/referrer-api/v1`;
let login_meta = document.head.querySelector('meta[name="login_url"]');
let login_url = '/login';
if (login_meta) {
    login_url = login_meta.content;
}
const LOGIN_URL = `${login_url}`;
export {
    LOGIN_URL,
    CSRF_TOKEN,
    API_BASE_URL,
    APPLICANT_API_BASE_URL,
    RECRUITER_API_BASE_URL,
    EXTERNAL_API_BASE_URL,
    REFERRER_PORTAL_BASE_URL,
    REFERRER_PORTAL_API_BASE_URL,
    USER_API_BASE_URL
}